import axios from 'axios';

const api = axios.create({
  baseURL: 'https://rgform-prod.leapeasyapi.com/api',
});

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `${token}`,
    },
  };
};

export const getProperty = async (data) => {
  const response = await api.get('/property?state=' + data);
  return response.data;
};

export const submitFormData = async (data) => {
  const response = await api.post('/shortform-create', data);
  return response.data;
};

export const getCoverageAmount = async (data) => {
  const response = await api.get('/coverageAmount?propertyId=' + data);
  return response.data;
};

export const emailVerify = async (data) => {
  const response = await api.post('/email-verify', data);
  return response.data;
};

export const getTenantInfo = async (data) => {
  const response = await api.get('/tenant?id=' + data);
  return response.data;
};
